// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__8GdeP","consentsList":"PatientConsents_consentsList__pVP2M","consentsListEmpty":"PatientConsents_consentsListEmpty__3BsyX"};